import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import Backdrop from 'src/component/Backdrop';
import BeforeAddToBasketPopup from 'src/component/BeforeAddToBasketPopup/BeforeAddToBasketPopup';
import Editor from 'src/component/Editor';
import EditorCrossSellPopup from 'src/component/EditorCrossSellPopup';
import EmptyDesignWarningPopup from 'src/component/EmptyDesignWarningPopup';
import FrameSelectorPopup from 'src/component/FrameSelectorPopup';
import LowDPIWarningPopup from 'src/component/LowDPIWarningPopup/LowDPIWarningPopup';
import QuantitySelectPopup from 'src/component/QuantitySelectPopup';
import TopBar from 'src/component/TopBar';
import UpdateDesignWarningPopup from 'src/component/UpdateDesignWarningPopup';
import { Store } from 'src/store';
import setProductBundleSelectedProductsOperation from 'src/store/productBundle/operation/setProductBundleSelectedProductsOperation';
import { BundledProduct } from 'src/store/productBundle/types';
import fillBundleGroupId from 'src/util/bundles/fillBundleGroupId';
import useQuery from 'src/util/hook/useQuery';
import styles from './index.module.scss';

export interface OwnProps {
  dispatch: ThunkDispatch<Store, void, AnyAction>;
}

export interface Props extends OwnProps {

}

const Home = ({ dispatch }: Props) => {
  const query = useQuery();

  useEffect(() => {
    const bundledProductsJson = query.get('bundledProducts');
    if (bundledProductsJson) {
      try {
        const decodedObject = JSON.parse(bundledProductsJson);

        if (Array.isArray(decodedObject)) {
          const originalEntriesCount = decodedObject.length;
          const bundledProducts: BundledProduct[] = [];

          decodedObject.forEach((entry, index) => {
            if (!entry || typeof entry !== 'object') {
              // eslint-disable-next-line no-console
              console.warn(`bundledProducts entry at index ${index} is not an object. Skipping.`);
              return;
            }

            const { bgid, pid } = entry as { bgid?: unknown; pid?: unknown };

            // Validate that values exist and are numbers
            if (bgid === undefined || bgid === null || pid === undefined || pid === null) {
              // eslint-disable-next-line no-console
              console.warn(`bundledProducts entry at index ${index} is missing bgid or pid. Skipping.`, entry);
              return;
            }

            const bundleGroupId = Number(bgid);
            const productId = Number(pid);

            // Validate that both are positive integers (> 0)
            // Number.isInteger checks for whole numbers, and > 0 ensures they're positive
            if (
              !Number.isInteger(bundleGroupId)
              || !Number.isInteger(productId)
              || bundleGroupId <= 0
              || productId <= 0
            ) {
              // eslint-disable-next-line no-console
              console.warn(`bundledProducts entry at index ${index} contains invalid numbers. Both bgid and pid must be positive integers. Skipping.`, entry);
              return;
            }

            bundledProducts.push({
              bundleGroupId,
              productId,
            });
          });

          if (bundledProducts.length > 0 || originalEntriesCount === 0) {
            dispatch(setProductBundleSelectedProductsOperation(bundledProducts));
          } else {
            // eslint-disable-next-line no-console
            console.warn('bundledProducts query param did not contain any valid entries. Skipping dispatch.');
          }
        } else {
          // eslint-disable-next-line no-console
          console.warn('bundledProducts query param is not an array. Skipping.');
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to parse bundledProducts query param. Skipping.', error);
      }
    }
    // when edit product from basket
    if (window.integrationLayer.editorMode === 'edit-from-basket' && window.integrationLayer.bundledProducts) {
      const bundledProducts = fillBundleGroupId(window.integrationLayer.bundledProducts);
      dispatch(setProductBundleSelectedProductsOperation(bundledProducts));
    }
  }, []);

  return (
    <div className={styles.home}>
      <TopBar />
      <Editor />
      <Backdrop />
      <FrameSelectorPopup />
      <EditorCrossSellPopup />
      <QuantitySelectPopup />
      <UpdateDesignWarningPopup />
      <EmptyDesignWarningPopup />
      <LowDPIWarningPopup />
      <BeforeAddToBasketPopup />
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Home);
